import { render, staticRenderFns } from "./SubjectTabs.vue?vue&type=template&id=5c41aca4&"
import script from "./SubjectTabs.vue?vue&type=script&lang=js&"
export * from "./SubjectTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports